import {Injectable} from '@angular/core';
import {RestService} from "./rest.service";

@Injectable({
  providedIn: 'root'
})
export class FuenteContratoService extends RestService {
  endpoint(): string {
    return "nFuenteContratacions";
  }
  param1(): string {
    return "nombre_fc";
  }

  param2(): string {
    return "id_planta";
  }

  param3(): string {
    return "orden_ceco";
  }
}


